export const getWindowLocationHref = () => {
  return window.location.href;
};